// extracted by mini-css-extract-plugin
export default {"main":"not-found-page_main__H31Wb"};